import { expandCollapse } from '../utils/expandCollapse';

const accordions = document.querySelectorAll('.accordion');
const accordionOpenClass = 'accordion--open';

const initAccordion = (accordion) => {
  const head = accordion.querySelector('.accordion__head');
  const body = accordion.querySelector('.accordion__body');
  const wrapper = accordion.closest('.accordion-wrapper');

  head.addEventListener('click', () => {
    expandCollapse(body, head);
    accordion.classList.toggle(accordionOpenClass);
  });

  if (wrapper) {
    wrapper.addEventListener('mouseenter', () => {
      wrapper.classList.add('is-animating');
    });

    wrapper.addEventListener('animationend', () => {
      wrapper.classList.remove('is-animating');
    });
  }
};

(() => {
  if (accordions.length) {
    accordions.forEach((accordion) => {
      initAccordion(accordion);
    });
  }
})();
